import { createSelector } from 'reselect';

const getProps = (_, props) => props;

export const getRoot = state => state;

/**  @param {{questionModels: import('modules/questionModels/reducer').QuestionModelReducer}} state */
export const getState = state => state.questionModels;

const getData = createSelector(getState, state => state.data);

export const getByIdState = createSelector(getData, data => data.byId);

export const getById = createSelector(getByIdState, getProps, (state, questionModelId) => state[questionModelId]);

export const getByIds = createSelector(getByIdState, getProps, (state, questionModelIds) =>
  questionModelIds.map(questionModelId => state[questionModelId]).filter(Boolean));

export const getDefaultQuestionId = createSelector(getData, data => data.defaultQuestionId);
